import { PlanningFilters } from "@landtechnologies/search-layer-contracts";
import Feature from "src/js/stores/user/Feature";
import { Layer, LayerGroup } from "../types";
import { PlanningApplicationsRecentSummaryLayerType } from "../layer_types/PlanningApplicationsLayerType/PlanningApplicationsLayerType";
import { PlanningApplicationsLayerType } from "../layer_types/PlanningApplicationsLayerType";
import type { PlanningApplicationsLayer } from "../layer_types/PlanningApplicationsLayerType/types/layerTypes";

export const PLANNING_APPLICATION_LAYER_SOURCING_TOOL: Layer = {
  id: "PLANNING_APPLICATIONS_SOURCING_TOOL",
  layerType: PlanningApplicationsLayerType,
  title: "Planning Applications",
  requiredFeatureAccess: [Feature.planningLayer],
  toggleable: false,
  description: "Planning applications and appeals",
  hideMapLayer: true,
  layerConfig: {
    localStorageKey: "planning-filter-sourcing-tool",
    initialFilterState: {
      maxYear: 100,
      minSize: 0,
    },
  },
};

export const PLANNING_APPLICATION_RECENT_SUMMARY_LAYER: Layer = {
  id: "PLANNING_APPLICATIONS__RECENT_SUMMARY",
  layerType: PlanningApplicationsRecentSummaryLayerType,
  title: "Recent applications",
  requiredFeatureAccess: [Feature.insightsSummary],
  description: "Summary of recent applications and appeals",
  hideMapLayer: true,
  toggleable: true,
};

export const PLANNING_APPLICATION_LAYER: PlanningApplicationsLayer = {
  id: "PLANNING_APPLICATIONS",
  layerType: PlanningApplicationsLayerType,
  title: "Planning applications",
  requiredFeatureAccess: [Feature.planningLayer],
  toggleable: true,
  group: LayerGroup.GENERAL,
  icon: "lt-layer-planning-applications",
  description: "Explore local planned developments",
  hideByDefault: true,
  layerConfig: {
    localStorageKey: "planning-filter-state-v2",
  },
};

const PLANNING_APPLICATION_FILTERS_ALL: Pick<PlanningFilters, "maxYear" | "minSize" | "enabledTypes"> = {
  maxYear: 35,
  minSize: 0,
  enabledTypes: [
    "fullApplication",
    "outline",
    "reservedMatters",
    "gpdr",
    "changeOfUse",
    "eia",
    "uncategorised",
    "tpo",
    "listedBuildings",
    "dischargeOfConditions",
  ],
};

export const PLANNING_APPLICATION_ASSESSMENT_LAYER: PlanningApplicationsLayer = {
  ...PLANNING_APPLICATION_LAYER,
  id: "PLANNING_APPLICATIONS_ASSESSMENT",
  layerConfig: {
    localStorageKey: "planning-filter-assessment",
    initialFilterState: {
      ...PLANNING_APPLICATION_FILTERS_ALL,
      maxYear: 5,
      minSize: 1,
      enabledTypes: PLANNING_APPLICATION_FILTERS_ALL.enabledTypes.filter(
        (type) => type !== "tpo" && type !== "listedBuildings" && type !== "dischargeOfConditions"
      ),
    },
  },
};
